import { SmartHomeComponent } from '@vi-iot/client/apis/smart-home-components/smart-home-components.model';

export const smartHomeComponentsMockedResponse: SmartHomeComponent[] = [
  {
    id: '1',
    name: 'AVM Fritz!',
    selected: false,
    deleted: false,
  },
  {
    id: '2',
    name: 'Bosch Smart Home',
    selected: true,
    deleted: false,
  },
  {
    id: '3',
    name: 'Danfoss',
    selected: true,
    deleted: false,
  },
  {
    id: '4',
    name: 'Digitale Thermostate (Discounter / Baumarkt)',
    selected: false,
    deleted: true,
  },
  {
    id: '5',
    name: 'eve',
    selected: false,
    deleted: false,
  },
  {
    id: '6',
    name: 'eQ-3',
    selected: false,
    deleted: false,
  },
  {
    id: '7',
    name: 'Homematic IP',
    selected: true,
    deleted: false,
  },
];
